import store from '../../store/index'
import Vue from 'vue';

async function salvaPedidoAPI(pagamento) {
    const dadosCompra = store.getters.dadosCompra
    const endereco = store.getters.endereco
    const empresa = store.getters.empresa
    const carrinhoProdutos = store.getters.cartProducts
    var idPedido = 0

    try {
        var itens = []
        carrinhoProdutos.map((i) => {
            var adicionais = []
            if (i.extras) i.extras.map((e) => {
                adicionais.push({ codigo: e.codigo, quantidade: e.quantidade ? e.quantidade * i.quantidade : i.quantidade, categoria: e.ctc_seqinterna > 0 ? e.ctc_seqinterna : 0, preco: e.preco })
            })

            itens.push({ codigo: i.codigo, descricao: i.descricao, quantidade: i.quantidade, observacao: i.observacao, sku: i.skuSelecionado.sku, adicionais: adicionais, preco: i.valorUnitario, imagem: i.imagem, valorAdicional: i.valorAdicional/i.quantidade })
        })

        const pedidoEndereco = {
            cep: endereco.cep,
            logradouro: endereco.logradouro,
            numero: endereco.numero,
            bairro: endereco.bairro,
            uf: endereco.uf,
            cidade: endereco.cidade,
        }

        var trocoPara = Number(dadosCompra.troco.toString().replace(',', '.'))

        const cliente = {
            nome: dadosCompra.nome,
            cpf: dadosCompra.cpf,
            email: dadosCompra.email,
            telefone: dadosCompra.telefone
        }

        const jsonBody = {
            cliente,
            formapagamento: dadosCompra.formaPagamento,
            fpaseqinterna: dadosCompra.fpaseqinterna,
            fplanoseqinterna: dadosCompra.fplanoseqinterna,
            observacao: dadosCompra.observacao,
            trocopara: trocoPara,
            entrega: endereco.entrega == 'Entrega' ? true : false,
            endereco: pedidoEndereco,
            empresa: empresa.api_key,
            itens: itens,
            vendedor: dadosCompra.vendedor,
            pagamento,
            identificadorCatalogo: store.getters.catalogo.identificadorCatalogo
        }

        const response = await Vue.axios.post(`/empresas/${empresa.id}/pedidos`, jsonBody)
        idPedido = response.data.id

        return response
    } catch (error) {
        window.console.log(error)
        throw error
    } finally {
        store.dispatch('addIdPedido', idPedido)
        store.dispatch('saveCart')
    }
}
export default async function salvaPedido(pagamento) { return await salvaPedidoAPI(pagamento) }